import FontAwesomeIcon from "./FontAwesomeIcon";

export default function PencilSquareIcon({ ...props }) {
  return <FontAwesomeIcon name="pencil-square" {...props} />;
}
